export interface Course {
  id: string;
  code: string;
  title: string;
  color: "blue" | "pink" | "green" | "purple";
}

export const courseData: Course[] = [
  {
    id: "course-102",
    code: "COURSE 102",
    title: "INTRODUCTION TO VOLUNTEERISM",
    color: "blue",
  },
  {
    id: "course-103",
    code: "COURSE 103",
    title: "INTRODUCTION TO PROFESSIONAL CONDUCT AND ETHICS",
    color: "pink",
  },
];
